<div class="card">
    <div class="card-header d-flex flex-column" style="gap: 1rem;">
        <div style="font-family: 'Lato';" *ngIf="title != '' " class=" m-1 d-flex align-items-baseline justify-content-start flex-column flex-sm-column text-left
            flex-wrap">
            <h2 style="color:#404b5a" *ngIf="title != ''" class="m-0 mr-2">{{title | slice:0:100 | uppercase}}</h2>

        </div>

        <div class="checkbox-section">

            <mat-form-field appearance="fill">
                <mat-label>Tienda</mat-label>
                <input matInput [(ngModel)]="store" [matAutocomplete]="autoTienda" [disabled]="showFieldInactive"
                    (keyup)="storeFilter($event)">
                <mat-autocomplete #autoTienda="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let tienda of storesFiltered" [value]="tienda">
                        {{tienda['C_AGE']}} - {{tienda['NOM']}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-checkbox class="checkbox-margin" [(ngModel)]="showFieldInactive" (click)="clear()">Agregar todas las
                tiendas</mat-checkbox>
        </div>

        <div class="card-footer d-flex align-items-center justify-content-end gap-2">
            <button mat-flat-button class="btn_cancel" type="button" (click)="close()">Cancelar</button>
            <button mat-flat-button type="submit" class="btn_save" (click)="save()"
                [disabled]="showFieldAudit || (!showFieldInactive && !store)">Agregar</button>
        </div>


    </div>

    <div style="font-family: 'Lato';" class="card-body text-center" *ngIf="data.length==0">
        No hay registros que mostrar
    </div>

    <div class="card-body overflow-auto p-0 ">
        <div class="table-container">
            <table mat-table *ngIf="data.length>0" [dataSource]="dataSource" class="mat-elevation-z8">


                <ng-container matColumnDef="{{item.name}}" *ngFor="let item of columns">
                    <th mat-header-cell *matHeaderCellDef class="pr-3 pl-3">{{item.title|uppercase}}</th>
                    <div *ngIf="item.name.toUpperCase() != 'ESTADO'">
                        <td mat-cell *matCellDef="let element" class="p-1 pr-3 pl-3" style="text-align: center;">
                            {{render(item, element)}}
                        </td>
                    </div>

                    <div *ngIf="item.name.toUpperCase() == 'ESTADO'">
                        <td mat-cell *matCellDef="let element" [ngClass]="{'text-break': render(item, element).length>40,
                        'text-wrap':render(item, element).length>20, 'text-nowrap':render(item, element).length<=20,
                        'td-align-center': item.name.toUpperCase() == 'ESTADO'}" class="p-1 pr-3 pl-3">

                            <button mat-flat-button
                                [ngClass]="element.ESTADO=='A' ? 'btn done' : element.ESTADO=='I' ? 'btn inactive': 'btn done'"
                                type="button" (click)="changeState(element.C_AGR,element.ESTADO)">
                                {{element.ESTADO=='A'
                                ? "Activo" : "Inactivo" }}</button>
                        </td>
                    </div>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [class.demo-row-is-clicked]="selected.has(row)"></tr>
            </table>

        </div>
    </div>
</div>